import { render, staticRenderFns } from "./OxideMineralInput.vue?vue&type=template&id=f5997234&scoped=true&lang=html&"
import script from "./OxideMineralInput.vue?vue&type=script&lang=js&"
export * from "./OxideMineralInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5997234",
  null
  
)

export default component.exports